module.exports = __webpack_public_path__ + "img/drop_right.126f88bc.svg";